import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import moment from "moment";

interface Details {
  id: number;
  name: string;
  title: string;
  email: string;
  phonenumber: string;
  website_url: string;
  address: string;
  address2: string;
  state: string;
  city: string;
  zipcode: string;
  coordinates: {
    type: string;
    coordinates: number[];
  };
  return_refund_policy: string;
  accepted_payment_methods: string;
  current_shipping_methods: string;
  comments: string;
  is_old_User: boolean;
  created_at: Date;
  updated_at: Date;
}

interface Props extends ModalProps {
  details: Details;
  handleSubmit?: () => void;
  actionButtonText?: string;
  loading?: boolean;
  title?: string;
}

const RequestViewModal = ({ title, details, show, handleClose }: Props) => {
  function isValidDate(date: any) {
    if (typeof date === "boolean") {
      return false;
    }
    const newDate = new Date(date);
    return newDate instanceof Date && !isNaN(newDate.getTime());
  }

  const formatLabel = (label: string): string =>
    label
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const userDetailsData = Object.entries(details).map(([key, value]) => ({
    label: formatLabel(key),
    value: isValidDate(value)
      ? moment(value).format("MMM DD, YYYY")
      : typeof value === "string" || typeof value === "number"
      ? value
      : "N/A",
  }));

  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={styles.modalTitle}>{title || "Details"}</h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => handleClose()}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-4")}
        >
          {userDetailsData.map(
            (item, index) =>
              item && (
                <div
                  key={index}
                  className={classNames(
                    styles.customerDetails,
                    "grid grid-cols-12"
                  )}
                >
                  <p className={classNames(styles.heading, "col-span-4")}>
                    <strong>{item.label}:</strong>
                  </p>
                  <p className={classNames(styles.value, "col-span-8")}>
                    {item.value || "N/A"}
                  </p>
                </div>
              )
          )}
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default RequestViewModal;
